import {
  Dialog as DialogCore,
  DialogTitle as DialogTitleCore,
  DialogContent as DialogContentCore,
  IconButton as IconButtonCore,
} from '@material-ui/core';
// DialogCore re-used below for ImagePreviewDialog
import * as lib from '~/dependencies';

export const Dialog = lib.styled(DialogCore)`
  .MuiDialog-paper {
    width: 400px;
    max-height: 480px;
    border-radius: 8px;
  }
`;

export const DialogTitle = lib.styled(DialogTitleCore)`
  padding: 12px 16px !important;
  border-bottom: 1px solid #f0f0f0;

  .title {
    font-size: 15px;
    font-weight: 600;
    font-family: Nunito, sans-serif;
  }
`;

export const CloseButton = lib.styled(IconButtonCore)`
  position: absolute !important;
  right: 8px !important;
  top: 50% !important;
  transform: translateY(-50%) !important;
`;

export const DialogContent = lib.styled(DialogContentCore)`
  padding: 8px 0 !important;
  overflow-y: auto;
`;

export const FileRow = lib.styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  border-bottom: 1px solid #f5f5f5;

  &:last-child {
    border-bottom: none;
  }
`;

export const FileThumb = lib.styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid #e8e8e8;
  position: relative;
`;

export const EyeOverlay = lib.styled.button`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.28);
  border: none;
  cursor: pointer;
  padding: 0;
  color: #fff;
  opacity: 0;
  transition: opacity 0.15s;

  ${FileThumb}:hover & {
    opacity: 1;
  }

  svg {
    font-size: 18px;
    filter: drop-shadow(0 1px 2px rgba(0,0,0,0.5));
  }
`;

export const ImagePreviewDialog = lib.styled(DialogCore)`
  .MuiDialog-paper {
    background: transparent;
    box-shadow: none;
    max-width: 90vw;
    max-height: 90vh;
  }
`;

export const ImagePreviewImg = lib.styled.img`
  max-width: 90vw;
  max-height: 90vh;
  display: block;
  border-radius: 6px;
`;

export const FileThumbImage = lib.styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const FileBadge = lib.styled.div`
  width: 100%;
  height: 100%;
  background: #f0f4fa;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  color: #2e4a73;
  letter-spacing: 0.3px;
`;

export const FileInfo = lib.styled.div`
  flex: 1;
  min-width: 0;
`;

export const FileName = lib.styled.span`
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: #222;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileSize = lib.styled.span`
  display: block;
  font-size: 11px;
  color: #888;
  margin-top: 2px;
`;

export const RemoveButton = lib.styled(IconButtonCore)`
  flex-shrink: 0 !important;
  padding: 6px !important;
  color: #aaa !important;

  &:hover {
    color: #ff6666 !important;
  }
`;

export const SizeWarning = lib.styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 8px 16px;
  padding: 8px 12px;
  border-radius: 6px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  font-size: 12px;
  color: #7a5700;
  font-family: Nunito, sans-serif;
`;
